import {
  GET_COLLECTION_RECORDS,
  GET_COLLECTION_RECORDS_SUCCESS,
  GET_COLLECTION_RECORDS_ERROR,
  GET_CART_LINKS,
  GET_CART_LINKS_SUCCESS,
  GET_CART_LINKS_ERROR
} from "../actions";
import EnumRecordTypes from "../../enums/enumRecordTypes";

const INIT_STATE = {
  selectedRecordType: EnumRecordTypes.Person,
  searchRecordType: EnumRecordTypes.Person,
  searchResult: [],
  selectedFilters: {},
  loading: false,
  error: "",
  recordCollectionItemList: {
    records: [],
    pagination: {
      pageNumber: 1,
      pageSize: 5,
      startIndex: 1,
      totalItemCount: 0,
      totalPages: 0,
    },
    selectedRecords: {},
    responseTime: null
  },
  getCartLinksError: "",
  cartLinks: null,
};

const getRecordType = (recordTypeString) => {
  let recordTypeValue = EnumRecordTypes.Person;
  for (const key in EnumRecordTypes) {
    if (key.toLowerCase() === recordTypeString.toLowerCase()) {
      recordTypeValue = EnumRecordTypes[key];
      break;
    }
  }
  return recordTypeValue;
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_COLLECTION_RECORDS:
      return { ...state, loading: true, error: "", recordCollectionItemList: null, selectedRecordType: typeof action.payload.recordType === "string" ? getRecordType(action.payload.recordType) : action.payload.recordType, displayStatus: action.payload.displayStatus, pageNumber: action.payload.pageNumber, parentRecordId: action.payload.parentRecordId, selectedFilters: action.payload.selectedFilters, vocabularyId: action.payload.vocabularyId, hasUserAccount: action.payload.hasUserAccount ? action.payload.hasUserAccount : "" };
    case GET_COLLECTION_RECORDS_SUCCESS:
      return { ...state, loading: false, error: "", recordCollectionItemList: action.payload };
    case GET_COLLECTION_RECORDS_ERROR:
      const recordCollectionItemList = { ...state.recordCollectionItemList, records: [] };
      recordCollectionItemList.pagination = { ...recordCollectionItemList.pagination, totalItemCount: 0, totalPages: 0 };
      return { ...state, loading: false, error: action.payload.message, recordCollectionItemList };
    case GET_CART_LINKS:
      return { ...state, loading: true, getCartLinksError: "", cartLinks: null };
    case GET_CART_LINKS_SUCCESS:
      return { ...state, loading: false, getCartLinksError: "", cartLinks: action.payload };
    case GET_CART_LINKS_ERROR:
      return { ...state, loading: false, getCartLinksError: action.payload.message, cartLinks: null };
    default:
      return { ...state };
  }
};
